// extracted by mini-css-extract-plugin
export default {"innerWrapper":"hy-z","tooltipWrapper":"iy-z","icon":"jy-z","tooltip":"ky-z","content":"ly-z"};